import styled from 'styled-components';
export const CardContainer = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: row;
    align-items: centre;
    justify-content: space-between;
    border-radius: 16px;
    background: #f5f5f5;
    align-self: stretch;
    margin-bottom: 36px;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`;

export const ModelText = styled.div`
    color: #121212;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
`;

export const RegistrationText = styled.div`
    color: #4b4b4b;
    font-size: 12px;
    line-height: 18px;
`;

export const VariantText = styled.div`
    color: #4b4b4b;
    font-size: 12px;
    line-height: 18px;
`;
